import { render, staticRenderFns } from "./AnalyticsConsent.vue?vue&type=template&id=2c867f60&scoped=true"
import script from "./AnalyticsConsent.vue?vue&type=script&lang=js"
export * from "./AnalyticsConsent.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsConsent.vue?vue&type=style&index=0&id=2c867f60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Viberary/repos/viberary-frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c867f60",
  null
  
)

export default component.exports